import { configureStore } from "@reduxjs/toolkit";
import { enrollmentApi } from "pages/slice";
import rootReducer from "./rootReducer";

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(enrollmentApi.middleware),
  // todo only allow this if in dev mode
  devTools: true,
});

export const persistor = store;
